<template>
    <v-container fluid>
        <v-row class="mb-2">
            <v-col cols="12" class="d-flex justify-end">
                <hide-deleted-switch v-model="hideDeleted" />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" class="text-center buttom-border table-head primary--text">
                <v-row no-gutters>
                    <v-col cols="4">
                        <v-row no-gutters>
                            <v-col cols="4" class="text-center table-head primary--text">Nombre</v-col>
                            <v-col cols="5" class="text-center table-head primary--text">Contrato</v-col>
                            <v-col cols="3" class="text-center table-head primary--text">Nº documentos</v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-row no-gutters>
                            
                            <v-col v-for="state in firstStates" cols="3" class="text-center table-head primary--text" :key="state.value">{{state.name}}</v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-row no-gutters>
                            <v-col v-for="state in lastStates" cols="3" class="text-center table-head primary--text" :key="state.value">{{state.name}}</v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>

            <div class="scrollable">
                <v-row no-gutters v-for="data in filteredDashboardData" :key="'row_'+data.id" >
                    <template>
                        <v-col cols="12" class="text-center table-head primary--text">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    <v-row no-gutters>
                                        <v-col cols="4" class="text-center align-self-end table-row" @click="$emit('click-dashboard-name', {id: data.id, 'username': data.name, state:'all'})">
                                            <doc-text-field v-if="data.id" dense hide-details :value="data.name" kind="text" readonly :disabled="data['del']" :is_table="true" :error="Boolean(data['color'])" :errorColor="data['color']"></doc-text-field>
                                            <doc-text-field v-else dense hide-details :value="data.name" kind="text" readonly :disabled="data['del']" :font_weight_black="true" :primary_color_text="true" :is_table="true"></doc-text-field>
                                        </v-col>
                                        <v-col cols="5" class="text-center align-self-end table-row">
                                            <doc-text-field v-if="data.id" dense hide-details :value="data.contract['text']" kind="text" readonly :disabled="data['del']" :error="Boolean(data.contract['color'])" :errorColor="data.contract['color']" :is_table="true"></doc-text-field>
                                            <doc-text-field v-else dense hide-details :value="data.contract['text']" kind="text" readonly :disabled="data['del']" :font_weight_black="true" :primary_color_text="true" :error="Boolean(data.contract['color'])" :errorColor="data.contract['color']" :is_table="true"></doc-text-field>
                                        </v-col>
                                        <v-col cols="3" class="text-center align-self-end table-row">
                                            <doc-text-field v-if="data.id" dense hide-details :value="data.docs_num['text']" kind="number" readonly :disabled="data['del']" :error="Boolean(data.docs_num['color'])" :errorColor="data.docs_num['color']" :is_table="true"></doc-text-field>
                                            <doc-text-field v-else dense hide-details :value="data.docs_num['text']" kind="number" readonly :disabled="data['del']" :font_weight_black="true" :primary_color_text="true" :error="Boolean(data.docs_num['color'])" :errorColor="data.docs_num['color']" :is_table="true"></doc-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row no-gutters> 
                                        <v-col v-for="(state, index) in firstStates" :key="index + '_' + data.id" cols="3" class="text-center align-self-end table-row" @click="$emit('click-dashboard-state', {id: data.id, state:index})">
                                            <doc-text-field v-if="data.id" dense hide-details :value="data.states[index]" kind="number" readonly :disabled="data['del']" :is_table="true"></doc-text-field>
                                            <doc-text-field v-else dense hide-details :value="data.states[index]" kind="number" readonly :disabled="data['del']" :font_weight_black="true" :primary_color_text="true" :is_table="true"></doc-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row no-gutters>
                                        <v-col v-for="(state, index) in lastStates" :key="index + '_' + data.id" cols="3" class="text-center align-self-end table-row" @click="$emit('click-dashboard-state', {id: data.id, state:index})">
                                            <doc-text-field v-if="data.id" dense hide-details :value="data.states[index]" kind="number" readonly :disabled="data['del']" :is_table="true"></doc-text-field>
                                            <doc-text-field v-else dense hide-details :value="data.states[index]" kind="number" readonly :disabled="data['del']" :font_weight_black="true" :primary_color_text="true" :is_table="true"></doc-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </template>
                </v-row>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import DocTextField from './DocTextField.vue';
import HideDeletedSwitch from './HideDeletedSwitch.vue';
export default {
    components: {
        DocTextField,
        HideDeletedSwitch,
    },
    props: {
        states: {
            type: Object,
            required: false,
            default: function () {
                return {};
            },
        },
        dashboardData: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        initialHideDeleted: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            hideDeleted: this.initialHideDeleted,
            firstStatesKeys: ['all', 'done', 'pending_review', 'pending'],
            lastStatesKeys: ['pending_connect', 'errors', 'deleted', 'deleted_done'],
        };
    },
    computed:{
        filteredDashboardData() {
            if (!this.hideDeleted) return this.dashboardData;
            return this.dashboardData.filter(data => !data['del']);
        },
        firstStates() {
            // let keys = Object.keys(this.states).slice(2,6);
            let keys = this.firstStatesKeys;
            let fstates = {};
            for (let i in keys) {
                fstates[keys[i]] = this.states[keys[i]];
            }
            return fstates;
        },
        lastStates() {
            // let keys = Object.keys(this.states).slice(6);
            let keys = this.lastStatesKeys;
            let lstates = {};
            for (let i in keys) {
                lstates[keys[i]] = this.states[keys[i]];
            }
            return lstates;
        }
    },
    watch: {
        hideDeleted() {
            this.$emit('update-hide-deleted', this.hideDeleted);
        },
    },
};
</script>

<style scoped>
    .buttom-border {
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .scrollable {
        max-height: 700px;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .scrollable::-webkit-scrollbar {
        display: none;
    }
</style>